import { useSetState } from '@mantine/hooks'
import React, { useContext, useEffect, useState } from 'react'
import { IDashboardMap, IHaryanaOverALlStats, ILearningIndicator, IReportLevel } from '../../../libs/data-access/types'
import { useAuth, useDashboardDate, useMentorReports } from '../../../libs/data-access'
import {calculateCurrentMonthForDashboard, handleColor, showToast } from '../../../utils/utility'
import useMasterData from '../../Hooks/useMasterData'
import moment from 'moment'
import { AppContext } from '../../../AppContext'
import { ROLES } from '../../../Routes/routes'
import useStudentWorkingDays from '../../../libs/data-access/src/StudentWorkingDays/useStudentWorkingDays'

export default function useDashboard() {
  const { fetchDashboardData, fetchDashboardDataNipun } = useDashboardDate();
  const { fetchStudentWorkingData, postStudentWorkingDataData } =
    useStudentWorkingDays();
  const { handleLoginLogs } = useAuth();

  const { user, role } = useContext(AppContext);

  const {
    getDistrictByStateId,
    districts,
    getBlocksByDistrictId,
    blocks,
    clusterSchools,
    getClusterByBlockId,
  } = useMasterData();

    const {

        fetchMentorVisitReport,
      } = useMentorReports();

  const [selectedMonth, setSelectedMonth] = useState<string | undefined>(
    calculateCurrentMonthForDashboard(),
  );
  const [selectedDistrict, setSelectedDistrict] = useState<string | undefined>(
    undefined,
  );
  const [selectedBlock, setSelectedBlock] = useState<string | undefined>(
    undefined,
  );
  const [selectedCluster, setSelectedCluster] = useState<string | undefined>(
    undefined,
  );
  const [selectedSession, setSelectedSession] = useState<string | undefined>(
    parseInt(moment().format("MM"), 10) > 4
      ? moment().add(1, "year").format("YYYY")
      : moment().format("YYYY"),
  );
  const [reportLevel, setReportLevel] = useState<IReportLevel>({
    levelNames: "state",
    districtName: "haryana",
    districtId: 0,
    blockName: "",
  });

  const [isFirst, setIsFirst] = useState<boolean>(true);
  const [isLoadingSchoolVisit, setIsLoadingSchoolVisit] =
    useState<boolean>(false);
    const [isLoadingVisit, setIsLoadingVisit] =
      useState<boolean>(false);
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [isLoadingHaryanaOverAllStats, setIsLoadingHaryanaOverAllStats] =
    useState<boolean>(false);
  const [haryanaOverAllStats, setHaryanaOverAllStats] = useState<
    IHaryanaOverALlStats[]
  >([]);

  const [isAdvancedSearch, setIsAdvancedSearch] = useState<any>(false);
  const [schoolCode, setSchoolCode] = useState<any>("");
  const [schoolData, setSchoolData] = useState<any>(null);
  const [schoolDataHit, setSchoolDataHit] = useState<boolean>(false);
  const [visitData, setVisitData] = useState<any>(null);
  const [visitDataHit, setVisitDataHit] = useState<any>(null);

  useEffect(() => {
    if (isFirst) {
      getDistrictByStateId(1).finally(() => setIsFirst(false));
    } else {
      if (role?.includes(ROLES.BLOCK)) {
        setSelectedDistrict(
          String(user?.details?.blockUserDetails?.district_Id),
        );
        setSelectedBlock(String(user?.details?.blockUserDetails?.block_Id));
        // if(user?.details?.blockUserDetails?.district_Id){
        //     getBlocksByDistrictId(user?.details?.blockUserDetails?.district_Id)
        // }
        // handleSearch()
      } else if (role?.includes(ROLES.DISTRICT)) {
        setSelectedDistrict(
          String(user?.details?.districtUserDetails?.district_Id),
        );
      } else {
        handleSearch();
      }
    }
  }, [isFirst]);

  useEffect(() => {
    if (selectedDistrict) {
      if (role?.includes(ROLES.DISTRICT)) {
        handleSearch();
      }
      getBlocksByDistrictId(+selectedDistrict);
    } else {
      // setIsSearching(false)
      // getHaryanaOverAllStats()
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (selectedBlock) {
      if (role?.includes(ROLES.BLOCK)) {
        if (user?.details?.blockUserDetails?.district_Id) {
          getBlocksByDistrictId(
            user?.details?.blockUserDetails?.district_Id,
          ).then((res) => handleSearch());
        }
      }
      getClusterByBlockId(+selectedBlock);
    }
  }, [selectedBlock]);

  // handler function
  const handleSearch = () => {
    setIsSearching(true);
    getHaryanaOverAllStats();
  };
  // APi function

  const getHaryanaOverAllStats = async () => {
    let payload = {
      DistrictId: Number(selectedDistrict ?? 0),
      BlockId: Number(selectedBlock ?? 0),
      ClusterId: Number(selectedCluster ?? 0),
    };
    setIsLoadingHaryanaOverAllStats(true);
    setIsLoadingSchoolVisit(true);
    const res = await fetchDashboardDataNipun(
      `NIPUN_Haryana_at_a_glancePr`,
      payload,
    );
    if (res.isSuccess) {
      setHaryanaOverAllStats(res?.data);
    } else {
      setHaryanaOverAllStats([]);
      showToast({
        type: "error",
        message: res?.message || "Fail to get Nipurn haryana data indicator",
      });
    }
    setIsLoadingHaryanaOverAllStats(false);
    setIsLoadingSchoolVisit(false);
    setIsSearching(false);
  };

  // const getHaryanaOverAllStats = async () => {
  //     setIsLoadingHaryanaOverAllStats(true)
  //     setIsLoadingSchoolVisit(true)
  //     const res = await fetchDashboardData(`NIPUN_Haryana_at_a_glancePr?DistrictId=${selectedDistrict ?? 0}&BlockId=${selectedBlock ?? 0}&ClusterId=${selectedCluster ?? 0}`)
  //     if (res.isSuccess) {
  //         setHaryanaOverAllStats(res?.data)
  //     }
  //     else {
  //         setHaryanaOverAllStats([])
  //         showToast({
  //             type: "error",
  //             message: res?.message || "Fail to get Nipurn haryana data indicator"
  //         })
  //     }
  //     setIsLoadingHaryanaOverAllStats(false)
  //     setIsLoadingSchoolVisit(false)
  //     setIsSearching(false)
  // }

  const handleSearchBySchoolCode = async () => {
    try {
      setIsLoadingSchoolVisit(true);

      const res = await fetchStudentWorkingData(
        `GetSchoolTeacherClassWiseStudentCount?schoolCode=${schoolCode}`,
      );
      setSchoolData(res.data);
      setSchoolDataHit(true);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingSchoolVisit(false);
    }
  };

const handleFetchVisitDetails = async () => {
  try {
    setIsLoadingVisit(true);

    const res = await fetchMentorVisitReport(
      `GetSchoolVisitSummary/${schoolCode}/${"All"}/${1}/${10}`,
    );

    setVisitData(res?.data?.data);
    setVisitDataHit(true);
  } catch (err) {
    console.error(err);
  } finally {
    setIsLoadingVisit(false);
  }
};


  useEffect(() => {
      let paylaod = {
        module_Name: "NIPUN_DASHBOARD",
        table_Name: "dashboardLogin",
        action: "LOGIN",
        new_Data: JSON.stringify({
          user_Id: user?.user_Id,
          role_Name: user?.role_Name,
          role_Id: user?.role_Id,
        },
        ),
        created_By: String(user?.user_Id),
      };
   handleLoginLogs(paylaod);
  }, [])

  return {
    reportLevel,
    isLoadingSchoolVisit,
    setIsLoadingSchoolVisit,
    isSearching,
    setIsSearching,
    districts,
    blocks,
    clusterSchools,
    handleSearch,
    selectedDistrict,
    setSelectedDistrict,
    selectedBlock,
    setSelectedBlock,
    selectedCluster,
    setSelectedCluster,
    selectedMonth,
    setSelectedMonth,
    isLoadingHaryanaOverAllStats,
    haryanaOverAllStats,
    selectedSession,
    setSelectedSession,
    isAdvancedSearch,
    setIsAdvancedSearch,
    schoolCode,
    setSchoolCode,
    handleSearchBySchoolCode,
    schoolData,
    schoolDataHit,
    visitData,
    visitDataHit,
    handleFetchVisitDetails,
    setVisitData,
    setSchoolData,
    isLoadingVisit,
  };
}
